export const assets = {
  cardIcon: "/assets/card-payment-icon.png",
  checkmarkIcon: "/assets/green-checkmark.webp",
  heroImage: "/assets/gospel-piano-coaching-hero.png",
  paypalLogo: "/assets/paypal-logo.png"
};

export const bookingPayment = {
  amount: 50,
  currency: "USD",
  displayAmount: "$50",
  paypalUrl: "https://www.paypal.com/paypalme/phodzonditsheni/50USD"
};

export const stats = [
  {
    value: "3",
    label: "videos reviewed"
  },
  {
    value: "1 hr",
    label: "private call"
  },
  {
    value: bookingPayment.displayAmount,
    label: "complete session"
  }
];

export const timezones = [
  {
    value: "SAST / GMT+2",
    label: "SAST - South Africa (GMT+2)",
    offset: 2
  },
  {
    value: "GMT / UTC",
    label: "GMT / UTC",
    offset: 0
  },
  {
    value: "WAT / GMT+1",
    label: "WAT - West Africa (GMT+1)",
    offset: 1
  },
  {
    value: "EAT / GMT+3",
    label: "EAT - East Africa (GMT+3)",
    offset: 3
  },
  {
    value: "BST / GMT+1",
    label: "BST - United Kingdom (GMT+1)",
    offset: 1
  },
  {
    value: "EST / UTC-5",
    label: "EST - Eastern Time (UTC-5)",
    offset: -5
  },
  {
    value: "CST / UTC-6",
    label: "CST - Central Time (UTC-6)",
    offset: -6
  },
  {
    value: "MST / UTC-7",
    label: "MST - Mountain Time (UTC-7)",
    offset: -7
  },
  {
    value: "PST / UTC-8",
    label: "PST - Pacific Time (UTC-8)",
    offset: -8
  },
  {
    value: "CET / GMT+1",
    label: "CET - Central Europe (GMT+1)",
    offset: 1
  },
  {
    value: "AEST / GMT+10",
    label: "AEST - Australia East (GMT+10)",
    offset: 10
  }
];

export const defaultTimezone = timezones[0].value;

export const steps = [
  {
    title: "Send 3 Videos",
    text: "Submit 3 recordings of your current piano playing level."
  },
  {
    title: "Share Your Goals",
    text: "Tell me exactly what you want to achieve musically."
  },
  {
    title: "Deep Analysis",
    text: "I assess your harmony, rhythm, technique, and musical gaps."
  },
  {
    title: "Custom Roadmap",
    text: "You receive a documented learning path tailored to your level."
  },
  {
    title: "1 Hour Strategy Call",
    text: "We walk through your growth plan and unlock your next level."
  }
];

export const benefits = [
  "Clarity on your real level",
  "Structured gospel learning system",
  "No more guessing what to practice",
  "Direct mentorship from an active musician",
  "Faster, focused improvement"
];
